export const colHeaders = [
    'Client Id',
    "<input type='checkbox' class='checker htCheckboxRendererInput' data-row='-1' data-col='0' title='Select Up to first 50' />",
    '',
    'Client/Entity Type',
    'Number',
    'First Name',
    'Middle Name',
    'Last/Entity Name',
    'Suffix',
    'Email',
    'Phone Number',
    'Location',
    'Group Name & No.',
    'Primary Task Type',
    'Fiscal Year End',
    'Status',
    'Role',
    'Integration',
    'Client Guid',
    'Sort Name'
];